import { fetchAction } from '../../actions';
import { RankAPI } from './api';
import { types } from './types';
import { CreateRankDTO } from '../api-types';

export const actions = {
    getRanks: () => fetchAction(RankAPI.getRanks(), types.GET_RANKS, {}),

    getRank: (id: string) => fetchAction(RankAPI.getRank(id), types.GET_RANK, { id }),

    getArea: (id: string) => fetchAction(RankAPI.getArea(id), types.GET_AREA, { id }),

    getDispatchGroup: () => fetchAction(RankAPI.getDispatchGroups(), types.GET_DISPATCH_GROUP, {}),

    createRank: (data: CreateRankDTO, callback?: () => void) =>
        fetchAction(RankAPI.createRank(data), types.CREATE_RANK, data, { success: callback }),
    updateRank: (id: string, data: CreateRankDTO, callback?: () => void) =>
        fetchAction(RankAPI.updateRank(id, data), types.UPDATE_RANK, { id, ...data }, { success: callback }),
    deleteRank: (id: string, callback?: () => void) =>
        fetchAction(RankAPI.deleteRank(id), types.DELETE_RANK, { id }, { success: callback }),
};
